import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation BookmarkGroupPost($groupPostId: String!) {
    createSavedGroupPost(groupPostId: $groupPostId) {
      id
    }
  }
`

export interface BookmarkGroupPostInput {
  groupPostId: string
}

export interface BookmarkGroupPostOutput {
  createSavedGroupPost: {
    id: string
  }
}

export const useBookmarkGroupPost = () =>
  useMutation<BookmarkGroupPostOutput, BookmarkGroupPostInput>(mutation)
